// extracted by mini-css-extract-plugin
module.exports = {"webviewSubheading":"ECardsPendingView_webviewSubheading__3eZgX","cardGrid":"ECardsPendingView_cardGrid__3qmwQ"};